import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Button, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {

    },
}));
const ButtonComp = ({ variant, className, color, children, ...rest }) => {
    const classes = useStyles();
    return (
        <Button
            variant={variant}
            className={clsx(classes.root, className)}
            color={color}
            {...rest}
        >{children}</Button>
    );
};

ButtonComp.propTypes = {
    variant: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.any.isRequired,
    color: PropTypes.string,
};

ButtonComp.defaultProps = {
    variant: "contained",
    className: "",
    color: "primary",
};

export default ButtonComp;